// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__INSFQ","colCheckbox":"styles_colCheckbox__1Pd6c"};